import React from 'react';
import type { ChangeLogItem } from '../../store/ChangeLogState';
import OptionalLegendRenderer from './OptionalLegendRenderer';
import * as S from './styled';

export interface Props {
  item: ChangeLogItem;
  imageNumber: number;
}

export const SliderPageLegend = ({ item, imageNumber }: Props) => {
  const titleLangKey = item.title.replace('.title', `.legend.${imageNumber}.title`);
  const contentLangKeys = [1, 2, 3].map((n) =>
    item.title.replace('.title', `.legend.${imageNumber}.content.${n}`)
  );

  return (
    <S.SliderPageLegendWrapperDiv>
      <OptionalLegendRenderer langKey={titleLangKey}>
        {contentLangKeys.map((langKey) => (
          <OptionalLegendRenderer key={langKey} langKey={langKey} />
        ))}
      </OptionalLegendRenderer>
    </S.SliderPageLegendWrapperDiv>
  );
};

export default SliderPageLegend;
